import { Button, Container } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import GoogleLogin from 'react-google-login';
import { useHistory } from 'react-router-dom';
import styles from '../style.module.scss';

const FooterComponent = (props) => {
  const { handleLoginError, handleLoginSuccess } = props;

  return (
    <Container maxWidth="lg">
      <Navbar
        expand="lg"
        className={`d-flex align-items-baseline ${styles.navbarBackground} ${styles.footerContainer}`}
      >
        <Navbar.Brand href="#">
          <div className={styles.imageContainer}>
            <img
              alt="arzooo-header-logo"
              className={styles.headerLogo}
              src="https://static.arzoopro.com/images/falcon-logo.png"
            ></img>
          </div>
          <small className="text-muted" style={{ whiteSpace: 'break-spaces' }}>
            Copyright 2024 © Falcon Inc | All Rights Reserved
          </small>
          <div className="d-flex">
            <div
              className={styles.icon1Container}
              onClick={() => window.open('https://www.linkedin.com/company/arzooo')}
            >
              <img
                alt="arzooo-header-logo"
                className={styles.headerLogo}
                src="/images/linkedin1.svg"
              ></img>
            </div>
            <div
              className={styles.icon1Container}
              onClick={() => window.open('https://www.facebook.com/arzoooIN')}
            >
              <img
                alt="arzooo-header-logo"
                className={styles.headerLogo}
                src="/images/facebook1.svg"
              ></img>
            </div>
            <div
              className={styles.icon1Container}
              onClick={() => window.open('https://twitter.com/arzoooIN')}
            >
              <img
                alt="arzooo-header-logo"
                className={styles.headerLogo}
                src="/images/twitter1.svg"
              ></img>
            </div>
            <div
              className={styles.icon1Container}
              onClick={() =>
                window.open('https://www.youtube.com/channel/UCFSvnaVbp30gNCAiGX4xkoA')
              }
            >
              <img
                alt="arzooo-header-logo"
                className={styles.headerLogo}
                src="/images/youtube1.svg"
              ></img>
            </div>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="justify-content-end align-items-center flex-grow-1">
            <Nav.Link href="#whyFalcon" className={`${styles.navItem} mr-4`}>
              Why falcon?
            </Nav.Link>
            <Nav.Link href="#features" className={`${styles.navItem} mr-4`}>
              Features
            </Nav.Link>
            <Nav.Link href="/register" className={`${styles.navItem} mr-4`}>
              <Button
                className={`${styles.commonButtonBg}`}
                variant="contained"
                color="primary"
                moenagage-id={JSON.stringify({
                  eventName: 'User_Registration_initiation',
                  eventSource: 'Footer of landing page',
                })}
              >
                Start Selling
              </Button>
            </Nav.Link>
            <Nav.Link href="/signin">
              <Button className={`${styles.outlinedButton}`} variant="outlined" color="primary">
                {' '}
                Sign In
              </Button>
              {/* <GoogleLogin
                clientId={
                  '868881563620-53i2nnhl1jrrrco4015u79214pjnncom.apps.googleusercontent.com'
                }
                render={(renderProps) => (
                  <Button
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled}
                    variant="outlined"
                    color="primary"
                  >
                    {' '}
                    Sign In
                  </Button>
                )}
                buttonText="Sign In"
                onSuccess={handleLoginSuccess}
                onFailure={handleLoginError}
                cookiePolicy={'single_host_origin'}
              /> */}
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
};
export default FooterComponent;
